import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useRoom } from "../hooks/useRoom";
import { JoinForm } from "../components/JoinForm";
import { VotingBoard } from "../components/VotingBoard";

export function RoomPage() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  const [memberId, setMemberId] = useState<string | null>(
    () => code ? localStorage.getItem(`rateyou_member_${code}`) : null
  );

  const { members, connected, roomName, generation, hasInit } = useRoom(code ?? "");

  useEffect(() => {
    if (!code) navigate("/");
  }, [code, navigate]);

  if (!code) return null;

  function handleJoined(id: string) {
    setMemberId(id);
  }

  if (!memberId) {
    return <JoinForm code={code} roomName={roomName} onJoined={handleJoined} />;
  }

  return (
    <VotingBoard
      code={code}
      roomName={roomName}
      members={members}
      myMemberId={memberId}
      connected={connected}
      generation={generation}
      hasInit={hasInit}
    />
  );
}
